'use client'; // Required since we pass this as a Container prop on a page.tsx.

import type { ReactNode } from 'react';
import styles from './object-grid.module.scss';

const ObjectGrid = ({ children }: { children?: ReactNode }) => {
	return <section className={styles.grid}>{children}</section>;
};

export default ObjectGrid;
